import { Component, } from "@angular/core";

//Services
import { RouterService } from "src/app/services/router/router.service";
import { LanguagesService } from "src/app/services/languagesService/languages.service";

@Component({
  selector: "app-take-picture",
  templateUrl: "./take-picture.page.html",
  styleUrls: ["./take-picture.page.scss"],
})
export class TakePicturePage {
  constructor(
    private routerService: RouterService,
    public languageService: LanguagesService,
  ) { }

  skip() {
    //this.routerService.redirect("login-chat");
    this.routerService.redirect("app/home");
  }
  get getTextIUPageTakePicture() {
    return this.languageService.textsIU.page_take_picture;
  }
}
